import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const purchases = [{
  name: 'Ashley R.',
  location: 'Austin, TX'
}, {
  name: 'Jessica M.',
  location: 'Denver, CO'
}, {
  name: 'Emily T.',
  location: 'Portland, OR'
}, {
  name: 'Sophia K.',
  location: 'Nashville, TN'
}, {
  name: 'Olivia B.',
  location: 'Scottsdale, AZ'
}, {
  name: 'Chloe S.',
  location: 'San Diego, CA'
}, {
  name: 'Mia L.',
  location: 'Miami, FL'
}, {
  name: 'Isabella C.',
  location: 'Seattle, WA'
}, {
  name: 'Madison P.',
  location: 'Charlotte, NC'
}, {
  name: 'Grace W.',
  location: 'Minneapolis, MN'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    const t = setTimeout(showPopup, 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(t);
    };
  }, []);
  return <>
      {visible && <div className="fixed bottom-4 left-4 z-50 animate-slide-in" data-id="element-220" data-mp="1sr4y203uzjgy">
          <div className="bg-white border-2 border-brand-gold shadow-2xl rounded-xl p-3 pr-8 max-w-[260px] relative overflow-hidden ring-2 ring-brand-blue/30" data-id="element-221" data-mp="2qe3zeo5hxfl6">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-brand-navy via-brand-gold to-brand-blue" data-id="element-222" data-mp="2lcekgxf5khrt" />
            <button onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-slate-400 hover:text-brand-ink transition-colors" aria-label="Dismiss notification" data-id="element-223" data-mp="2ce2wz49l203l">
              <XIcon className="w-3.5 h-3.5" data-id="element-224" data-mp="10xusgxalcepa" />
            </button>
            <div className="flex items-center gap-3" data-id="element-225" data-mp="12f9xhzve4idn">
              <div className="w-9 h-9 rounded-full bg-brand-gold/15 flex items-center justify-center shrink-0 border border-brand-gold/40" data-id="element-226" data-mp="12gkxrppmn800">
                <ShoppingBagIcon className="w-4.5 h-4.5 text-brand-gold" data-id="element-227" data-mp="shvpmonj91wy" />
              </div>
              <div className="leading-tight" data-id="element-228" data-mp="xggjm6c6ypcy">
                <p className="font-bold text-brand-ink text-sm" data-id="element-229" data-mp="xf5dw0z6r7j7">
                  {current.name}
                </p>
                <p className="text-[11px] text-slate-500 font-medium" data-id="element-230" data-mp="jn8qga8gplt5">
                  {current.location}
                </p>
                <p className="text-xs text-brand-blue font-bold mt-0.5" data-id="element-231" data-mp="9re351tan2k1">
                  just purchased {PRODUCT_NAME}
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}